import { getCookie } from "../src/utils/cookies";
import { OpenAPI } from "./requests/core/OpenAPI";

OpenAPI.WITH_CREDENTIALS = true;
OpenAPI.CREDENTIALS = 'include';

OpenAPI.interceptors.request.use(async (request) => {
  const csrfToken = getCookie('csrftoken');

  const headers: Record<string, string> =
    request.headers instanceof Headers
      ? Object.fromEntries(request.headers.entries())
      : { ...(request.headers as Record<string, string>) };

  if (csrfToken) {
    headers['X-CSRFToken'] = csrfToken;
  }

  request.headers = headers;
  return request;
});
